<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import MainMenuItem from '@/components/main-menu-item'
import logo from '@/components/logo'

export default {
  name: 'main-menu',
  data () {
    return {}
  },
  components: {
    'menu-item': MainMenuItem,
    'logo-bk': logo
  },
  computed: {
    ...mapGetters([ 'isAuthenticated' ]),
    ...mapState([ 'cart', 'activeMenuIndex' ]),
    menus () {
      let isAuthenticated = this.isAuthenticated
      return this.$router.options.routes.filter(function (route) {
        return route.meta.showPublic && !isAuthenticated ||
          route.meta.showProtected && isAuthenticated
      })
    }
  },
  methods: {
    ...mapActions([ 'aLogout' ]),
    getRouteLabel (route) {
      if (this.isAuthenticated) {
        if (route.meta.labelProtected) {
          return route.meta.labelProtected
        }
      }
      if (!this.isAuthenticated) {
        if (route.meta.labelPublic) {
          return route.meta.labelPublic
        }
      }
      return route.meta.label
    },
    handleSelect (key, keyPath) {
    },
    handleMethod (methodName) {
      if (methodName) {
        this[ methodName ]()
      }
    },
    logout () {
      this.aLogout()
    }
  }
}
</script>

<template>
  <el-menu
    :default-active="activeMenuIndex"
    mode="horizontal"
    :router="true"
    @select="handleSelect"
  >
    <el-menu-item index="/">
      <logo-bk width=50 height=50></logo-bk>
    </el-menu-item>
    <menu-item
      v-for="menu in menus"
      :key="menu.name"
      :menu="menu"
    ></menu-item>
  </el-menu>
</template>



// WEBPACK FOOTER //
// src/components/main-menu.vue